<template>
    <CContainer class="mt-4">
      <BusinessTracking :IdDirectory="selectedIdDirectory" />
    </CContainer>
  </template>
  <script>
    import BusinessTracking from "@/components/datagrids/BusinessTracking.vue";

    export default {
      name: "BusinessTrackingTab",
      data() {
        return {
          selectedIdDirectory: ""
        }    
      },
      components: {
        BusinessTracking
      },
      methods: {
      },
      computed: {
        selectedDirectory() {
          return this.$store.state.selectedDirectory
        },
      },
      created() {
        this.selectedIdDirectory = this.$store.state.selectedDirectory.id_Directorio;
      },
      mounted(){
      }
    }
  </script>
  